import { Divider, Select } from 'antd';
import React, { useEffect } from 'react';
import ImageContainer from '../../General/ImageContainer';
import './SelectInputStyle.css';

export const DividerOption = {
    label: '-',
    value: ''
}

const styles = {
    angleDownIcon: {
        width: '14px',
        marginRight: '5px'
    }
}

const optionClass = err => { return err ? 'option-list-item-error' : 'option-list-item' };

const filterOptionsByLabel = (inputValue, option) => {
    return option.label.toString().toLowerCase().includes(inputValue.toLowerCase());
}

//takes an onChange prop and calls it with (dataKey, newValue)
const SelectInput = props => {
    const { def, dataKey, data, onChange, state, warning, name, filterOption } = props;
    const err = warning !== undefined && warning !== '' ? "error" : "";

    useEffect(() => {
        checkValue(data);
        
    }, [data])

    const checkValue = value => {
        let newValue = value;

        if (def && value && def.values.map(v => v).indexOf(value) === -1) {
            newValue = '';
        }

        onChange(dataKey, newValue);
    }

    const placeholder = (label) => {
        var firstLetter = label.toLowerCase().slice(0, 1);
        if (firstLetter === 'a' || firstLetter === 'e' || firstLetter === 'i' || firstLetter === 'o' || firstLetter === 'u') {
            return `-- Please select an ${label} --`
        }
        else {
            return `-- Please select a ${label} --`
        }
    }

    const placeholderText = placeholder(def.label);

    const ddOptions = def.values.map((val, idx) => {
        var opt = { label: def.options[idx], value: val, className: optionClass(err) };
        if (opt.label === DividerOption.label && opt.value === DividerOption.value) { //is a divider and needs to be rendered specially
            opt.label = <Divider style={{ height: '50%', margin: '10px 0px 0px 0px', borderColor: 'gray' }} />;
            opt.disabled = true;
        }
        return opt;
    });

    ddOptions.unshift({ value: null, label: placeholderText, className: optionClass(err) })

    return <Select
        value={data ? data : null} //this is so that the dropdown starts at the top of the list if there isn't a selected answer
        options={ddOptions}
        disabled={state.readonly} //so component does not complain
        showSearch={true}
        placeholder={placeholderText}
        onChange={(e, { value }) => checkValue(value)}
        status={err}
        suffixIcon={<ImageContainer iconName='angle-down' styles={styles.angleDownIcon} className='fontawesomeTextGrey' />}
        data-input={name || 'selectinput_de'}
        className={'selectinput_de'}
        filterOption={filterOption || filterOptionsByLabel}
        getPopupContainer={trigger => trigger.parentNode}
    />
}

export default SelectInput;
